module.exports = __webpack_public_path__ + "img/logo-ciudadelamexico.1e409ea7.png";